/**
 * Archivo Js que permite definir, administrar, controlar y configurar la instancia principal de vuejs 
 * en la aplicacion
 */

/**Definicion de componentes o librerias necesarioas que se complementan instancia de vuejs */
import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router.js'
import store from '@/store'
import Vuelidate from 'vuelidate'
import vuetify from '@/plugins/vuetify';
import '@mdi/font/css/materialdesignicons.css'
import lodash from 'lodash'
import VueLodash from 'vue-lodash'
import Default from '@/layout/Default.vue'
import Blank from '@/layout/Blank.vue'
import httpClientAxios from '@/gateway/axios'
import VueJWT from 'vuejs-jwt'
import { hasRole } from '@/directive/directive'
import UUID from "vue-uuid";
import VueMoment from 'vue-moment'

Vue.use(UUID);

/**Cargamos el componente de diseño por defecto en la instancia principal */
Vue.component('default-layout', Default)

/**Cargamos el componente de diseño la instancia principal */
Vue.component('blank-layout', Blank)

/**Configuramos la aplicacion para ser de produccion */
Vue.config.productionTip = false

/**Cargamos el componente de validacion */
Vue.use(Vuelidate)

Vue.use(VueMoment)

/**Cargamos el componente de lodash libreria que permite simplicar el manejo de objectos y arrays */
Vue.use(VueLodash, {lodash :  lodash})

/**Cargamos y centralizamos las peticiones con Axios */
Vue.prototype.$httpClient = httpClientAxios;

/**Cargamos el componente JWT que permite el manejo de token en las peticiones */
Vue.use(VueJWT, {
  keyName: 'USER_TOKEN'
})

/**Cargamos la directiva hasRole que permite validad los permisos de los usuarios */
Vue.directive('hasRole', hasRole);

/**Configuramos los path principales de la aplicacion */
// httpClientAxios.defaults.baseURL = 'http://localhost:8081';
// httpClientAxios.defaults.formLoginUrl = 'http://localhost:8763';
// httpClientAxios.defaults.referenciacion = 'http://localhost:8084';
// httpClientAxios.defaults.urlMSAPrestadores = 'http://localhost:9051';
// httpClientAxios.defaults.covid19Url = 'http://localhost:8085';

// httpClientAxios.defaults.fileManager = 'http://localhost:8770';
// httpClientAxios.defaults.msaResultados = 'http://localhost:8087';
// httpClientAxios.defaults.visorPdf = 'http://localhost:8080';

httpClientAxios.defaults.fileManager = 'https://publicpdnmsafamisoft1.eastus2.cloudapp.azure.com:8770';
httpClientAxios.defaults.msaResultados = 'https://publicpdnmsafamisoft1.eastus2.cloudapp.azure.com:8087';
httpClientAxios.defaults.visorPdf = 'https://pdnappfamisoftcovidsa.z20.web.core.windows.net';


/**Cargamos la libreria JWT en Axios */
httpClientAxios.defaults.JWT = Vue.$jwt;

/**Instancia principal de la aplicacion */
new Vue({

  /**Inyectamos el router de la aplicacion */
  router,

  /**Inyectamos el almacen de estados de la aplicacion */
  store,

  /**Inyectamos Vuetify mejorando la estetica con material Design y acelerando el desarrollo de la aplciacion*/
  vuetify,

  /**Renderizamos el contenido de la aplicacion en la vista App */
  render: h => h(App)
}).$mount('#app')
